import { useLcaBreakdownData } from '@/stores/pathwayTemplateAnalysisStore';
import CostBreakdownChart from '../charts/CostBreakdownChart';
import { parseLCABreakdownData, parseLCAData } from '@/utils/analysisUtils';
import { aggregateMinorContributors } from '@/utils/miscUtils';
import { getEmissionsUnit } from '@/utils/pathwayTemplateUtils';
import LoadingSkeleton from '../core/LoadingSkeleton';

const DEFAULT_MINOR_THRESHOLD_FRACTION = 0.01;
const MINOR_CONTRIBUTORS_LABEL = 'Minor Contributors';

const LcaBreakdownContainer = () => {
  const { data, loading, error } = useLcaBreakdownData();

  if (loading && !data) return <LoadingSkeleton />;
  if (error) return <div>Error: {error.message}</div>;

  const results = parseLCAData(data);
  const lcaResultsBreakdown = parseLCABreakdownData(results);
  const displayBreakdown = aggregateMinorContributors(lcaResultsBreakdown, {
    thresholdFraction: DEFAULT_MINOR_THRESHOLD_FRACTION,
    minorLabel: MINOR_CONTRIBUTORS_LABEL,
  });
  const unit = getEmissionsUnit(data);

  return (
    <CostBreakdownChart
      breakdownResults={displayBreakdown}
      yAxisLabel={`Scope 3 Breakdown\n[${unit}]`}
      unit={unit}
      variant="doughnut"
    />
  );
};

export default LcaBreakdownContainer;
